<ng-container *ngIf="!displayLegalEntityFields; else legalEntityFields">
  <div class="row person-autocomplete mx-none">
    <div class="col-12">
      <p class="label company">{{ 'legalEntity.autocompletePlaceholder' | translate }}</p>
      <div class="row mb-sm mx-none">
        <div>
          <div class="row">
            <div class="col-12 col-md-12 mb-sm px-none">
              <well-legal-entity-autocomplete
                placeholder="{{ 'legalEntity.autocomplete' | translate }}"
                [searchLocation]="legalEntitySearchLocation"
                (legalEntitySelect)="onLegalEntitySelect($event)"
                [filterLocalCompaniesWithoutCompanyType]="true"
                (addCompany)="addNewCompany()" data-testid="legal-entity-autocomplete">
              </well-legal-entity-autocomplete>
            </div>
          </div>
        </div>
      </div>

      <div class="d-flex align-items-center color-gray">
        <i class="ui-icon-warning mr-xs"></i>
        <label class="anaf-company-label">{{ 'legalEntity.existentAnafCompanyLabel' | translate }}</label>
      </div>

      <ng-container *ngIf="form && form.errors && form.dirty">
        <p class="text-danger">
          {{ 'legalEntity.error.noLegalEntityCreated' | translate }}
        </p>
      </ng-container>
    </div>
  </div>
</ng-container>

<ng-template #legalEntityFields>
  <form *ngIf="form" [formGroup]="form" (ngSubmit)="onSubmit()">
    <div class="row mx-none">
      <div class="col-12 col-lg-12">
        <div class="form-container fields mb-sm me-5">
          <div formGroupName="legalEntityDTO">
            <div class="close-button" *ngIf="!legalEntity?.uuid">
              <button
                pButton
                icon="ui-icon-arrow-back"
                label="{{ 'legalEntity.closeInputs' | translate }}"
                type="button"
                class="flat close mb"
                (click)="hideLegalEntityFields()" data-testid="hide-legal-entity-fields-btn"></button>
            </div>

            <div class="row pb">
              <div class="form-field">
                <p-floatlabel variant="on">
                  <input
                    id="companyName"
                    pInputText
                    formControlName="companyName"
                    formInlineError="signup.error"
                    type="text"
                    style="width: 100%" data-testid="company-name-input"/>
                  <label for="companyName">{{ 'legalEntity.inputs.companyName' | translate }} *</label>
                </p-floatlabel>
              </div>
            </div>

            <div class="row pb">
              <div class="form-field">
                <p-floatlabel variant="on">
                  <input
                    id="uniqueIdNumber"
                    pInputText
                    formControlName="uniqueIdNumber"
                    formInlineError="signup.error"
                    [pattern]="uniqueIdNumberPattern"
                    type="text"
                    style="width: 100%" data-testid="unique-id-number-input"/>
                  <label for="uniqueIdNumber">{{ 'legalEntity.inputs.uniqueIdNumber' | translate }} *</label>
                </p-floatlabel>
              </div>
            </div>

            <div class="row pb">
              <div class="form-field">
                <p-floatlabel variant="on">
                  <input
                    id="registrationCode"
                    pInputText
                    formControlName="registrationCode"
                    type="text"
                    style="width: 100%" data-testid="registration-code-input"/>
                  <label for="registrationCode">{{ 'legalEntity.inputs.registrationCode' | translate }}</label>
                </p-floatlabel>
              </div>
            </div>

            <div class="row pb">
              <div class="form-field">
                <p-floatlabel variant="on">
                  <well-country-dropdown
                    id="country"
                    formControlName="country"
                    formInlineError="signup.error" data-testid="country-dropdown"/>
                  <label for="country">{{ ('legalEntity.inputs.country' | translate) + ' *' }}</label>
                </p-floatlabel>
              </div>
            </div>

            <div class="row pb">
              <div class="form-field">
                <p-floatlabel variant="on">
                  <input id="mainPhone" pInputText formControlName="mainPhone" type="text" style="width: 100%" data-testid="main-phone-input"/>
                  <label for="mainPhone">{{ 'legalEntity.inputs.mainPhone' | translate }}</label>
                </p-floatlabel>
              </div>
            </div>

            <div class="row pb">
              <div class="form-field">
                <p-floatlabel variant="on">
                  <input
                    id="mainEmailAddress"
                    pInputText
                    formControlName="mainEmailAddress"
                    type="text"
                    style="width: 100%" data-testid="main-email-address-input"/>
                  <label for="mainPhone">{{ 'legalEntity.inputs.mainEmailAddress' | translate }}</label>
                </p-floatlabel>
              </div>
            </div>

            <div class="row pb">
              <div class="form-field">
                <p-floatlabel variant="on">
                  <well-select-items-dropdown
                    formControlName="industryTypeValue"
                    [style]="{ width: '100%' }"
                    [field]="'industryTypeValue'"
                    [label]="'legalEntity.inputs.industryType' | translate" data-testid="industry-type-value-dropdown"></well-select-items-dropdown>
                </p-floatlabel>
              </div>
            </div>

            <div class="row pb">
              <div class="form-field">
                <p-floatlabel variant="on">
                  <p-select
                    [autoDisplayFirst]="false"
                    [options]="languages"
                    formControlName="preferredLanguage"
                    formInlineError="signup.error"
                    [style]="{ width: '100%' }"
                    id="preferredLanguage" data-testid="preferred-language-select">
                  </p-select>
                  <label for="preferredLanguage">{{ 'legalEntity.inputs.preferredLanguage' | translate }} *</label>
                </p-floatlabel>
              </div>
            </div>

            <div class="row pb">
              <div class="form-field">
                <div class="d-flex align-items-center">
                  <p-checkbox
                    id="vatRegistration"
                    [formControl]="vatRegistrationFormControl"
                    [binary]="true"
                    wellDialogInsertion
                    [dialogData]="getDumpDialogData()" data-testid="vat-registration-checkbox"></p-checkbox>
                  <label class="ml checkbox-label-text" for="vatRegistration">{{
                    'legalEntity.inputs.vatRegistration' | translate
                  }}</label>
                </div>
              </div>
            </div>

            <div class="row pb">
              <div class="form-field">
                <div class="d-flex align-items-center">
                  <p-checkbox
                    id="vatSplitStatusFormControl"
                    [formControl]="vatSplitStatusFormControl"
                    [binary]="true"
                    wellDialogInsertion
                    [dialogData]="getDumpDialogData()" data-testid="vat-split-status-form-control-checkbox"></p-checkbox>
                  <label class="ml checkbox-label-text" for="vatSplitStatusFormControl">{{
                    'legalEntity.inputs.vatSplitStatus' | translate
                  }}</label>
                </div>
              </div>
            </div>

            <p-divider align="left">
              <p>{{ translationSchema.legalEntity.inputs.officeAddress | translate }} (*)</p>
            </p-divider>
            <div class="row pb">
              <div class="col-12 form-field">
                <p-floatlabel variant="on">
                  <well-address-picker
                    id="officeAddressDTO"
                    formControlName="officeAddressDTO"
                    formInlineError="legalEntity.error"
                    [searchLocal]="false"
                    [validateForDistance]="false"
                    [displayTypeField]="false"
                    [hideFieldsUntilInput]="true"
                    [displayVisibilityField]="false"
                    [dirty]="form?.dirty"
                    [touched]="form?.touched"
                    [showOfficeAddressInfoMessage]="true"
                    [companyRequired]="true" data-testid="office-address-dto-picker">
                  </well-address-picker>
                </p-floatlabel>
              </div>
            </div>

            <p-divider align="left">
              <p>{{ translationSchema.legalEntity.inputs.financialAddress | translate }} (*)</p>
            </p-divider>
            <div class="row pb">
              <div class="col-12 form-field">
                <p-floatlabel variant="on">
                  <well-address-picker
                    id="financialAddressDTO"
                    formControlName="financialAddressDTO"
                    formInlineError="legalEntity.error"
                    [searchLocal]="false"
                    [validateForDistance]="false"
                    [displayTypeField]="false"
                    [hideFieldsUntilInput]="true"
                    [displayVisibilityField]="false"
                    [dirty]="form?.dirty"
                    [touched]="form?.touched"
                    [companyRequired]="true" data-testid="financial-address-dto-picker">
                  </well-address-picker>
                </p-floatlabel>
              </div>
            </div>

            <div class="row pb">
              <div class="form-field">
                <div class="d-flex align-items-center">
                  <p-checkbox
                    id="vatInactiveStatusFormControl"
                    [formControl]="vatInactiveStatusFormControl"
                    [binary]="true"
                    wellDialogInsertion
                    [dialogData]="getDumpDialogData()" data-testid="vat-inactive-status-form-control-checkbox"></p-checkbox>
                  <label class="ml checkbox-label-text" for="vatInactiveStatusFormControl">{{
                    'legalEntity.inputs.vatInactiveStatus' | translate
                  }}</label>
                </div>
              </div>
            </div>

            <div class="row pb">
              <div class="form-field">
                <p-floatlabel variant="on">
                  <p-datePicker
                    [readonlyInput]="true"
                    id="vatInactivationDate"
                    styleClass="col-12"
                    formControlName="vatInactivationDate"
                    dataType="string"
                    appendTo="body"
                    dateFormat="yy-mm-dd" data-testid="vat-inactivation-date-datepicker">
                  </p-datePicker>
                  <label for="vatInactivationDate">{{ 'legalEntity.inputs.vatInactivationDate' | translate }}</label>
                </p-floatlabel>
              </div>
            </div>
          </div>

          <div class="row pb" *ngIf="hasInvoiceSeriesPrefix">
            <div class="form-field">
              <p-floatlabel variant="on">
                <input
                  id="invoiceSeriesPrefix"
                  pInputText
                  formControlName="invoiceSeriesPrefix"
                  formInlineError="signup.error"
                  type="text"
                  style="width: 100%" data-testid="invoice-series-prefix-input"/>
                <label for="invoiceSeriesPrefix">{{ 'signup.invoiceSeriesPrefix' | translate }} *</label>
              </p-floatlabel>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="d-flex justify-end mb-3 me-4">
      <button
        [style]="{ width: '130px' }"
        [label]="'signup.save' | translate"
        type="submit"
        pButton
        class="p-button-outlined save-button" data-testid="invoice-series-prefix-btn"></button>
    </div>
  </form>
</ng-template>


